var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 40",
    style: {
      enableBackground: "new 0 0 32 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,16.6c-0.2-0.3-0.5-0.4-0.8-0.4h-1.8v-2c0-2-1.6-3.6-3.6-3.6h-11l-2.5-2.5c-0.2-0.2-0.4-0.3-0.7-0.3H4.6 c-2,0-3.6,1.6-3.6,3.6v17c0,2.1,1.7,3.8,3.8,3.8h21c0.4,0,0.8-0.3,1-0.7l4.2-14C31,17.2,31,16.9,30.8,16.6z M3,11.4 c0-0.9,0.7-1.6,1.6-1.6H10l2.5,2.5c0.2,0.2,0.4,0.3,0.7,0.3h11.4c0.9,0,1.6,0.7,1.6,1.6v2H7.6c-0.4,0-0.8,0.3-0.9,0.7L3,27.8V11.4z  M25.1,30.2H4.8c-0.2,0-0.3,0-0.5-0.1l4-11.9h20.3L25.1,30.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.e0d331eba6182bb5432afe049721aafe.svg";
export { ForwardRef as ReactComponent };